// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loader_spinner__H8Chs","sk-bouncedelay":"Loader_sk-bouncedelay__2zIYD","bounce1":"Loader_bounce1__2Tq2D","bounce2":"Loader_bounce2__3_c4i"};